module.exports = __webpack_public_path__ + "static/media/PDF_icon.95c81330.png";